import { useNavigate } from "react-router-dom";

export default function AfterLoginNav({ title, hasBack = null }) {
  return (
    <div className="header-login-nav">
      <img src={"/images/logo-black-font.svg"} />
      {title}
      {hasBack && (
        <div className="back-to-prev" onClick={hasBack}>
          <img src={"/images/svg/caret-left.svg"} alt={""} />
        </div>
      )}
    </div>
  );
}
